import NL from 'assets/images/flags/nl.svg';
import US from 'assets/images/flags/us.svg';
import AU from 'assets/images/flags/au.svg';
import NZ from 'assets/images/flags/nz.svg';
import BR from 'assets/images/flags/br.svg';
import CA from 'assets/images/flags/ca.svg';
import CAEN from 'assets/images/flags/ca.svg';
import CAFR from 'assets/images/flags/ca.svg';
import CN from 'assets/images/flags/cn.svg';
import DK from 'assets/images/flags/dk.svg';
import FI from 'assets/images/flags/fi.svg';
import SE from 'assets/images/flags/se.svg';
import NO from 'assets/images/flags/no.svg';
import FR from 'assets/images/flags/fr.svg';
import DE from 'assets/images/flags/de.svg';
import IN from 'assets/images/flags/in.svg';
import GB from 'assets/images/flags/gb.svg';
import IE from 'assets/images/flags/ie.svg';
import IT from 'assets/images/flags/it.svg';
import JP from 'assets/images/flags/jp.svg';
import MX from 'assets/images/flags/mx.svg';
import KO from 'assets/images/flags/kr.svg';
import MEAST from 'assets/images/flags/meast.svg';

const langs = {
  US,
  DE,
  AU,
  GB,
  CA,
  FR,
  CAFR,
  CAEN,
  MX,
};

export default langs;
